import Loadable from '@townsquare/loadable';
import { notificationsRoute } from '@townsquare/routes/notifications';

const FullPageNotifications = Loadable({
  loader: () => import(/* webpackChunkName: "notifications-view" */ './FullPageNotifications'),
  loading: () => null,
});

notificationsRoute.component = FullPageNotifications;
export const notificationsRouterRoute = notificationsRoute;
